// orderUtils.js
import { getFacturaPdf, getAlbaranPdf, getSignedAlbaranPdf, getOrderPhotos, getResumenPdf, logError } from '../../api';

export const handleDownloadFactura = async (orderId) => {
    try {
      const response = await getFacturaPdf(orderId);

      if (response && response.data && response.data.base64Pdf) {
        const base64String = response.data.base64Pdf;

        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${base64String}`;
        link.download = response.data.fileName;
        link.click();
      } else {
        alert('El archivo PDF está vacío o no se pudo obtener.');
      }
    } catch (error) {
      logError(error);
      console.error('Error al descargar la factura:', error);
      alert('No se pudo descargar la factura.');
    }
  };

export const handleDownloadAlbaran = async (orderId) => {
    try {
      const response = await getAlbaranPdf(orderId);

      if (response && response.data && response.data.base64Pdf) {
        const base64String = response.data.base64Pdf;

        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${base64String}`;
        link.download = response.data.fileName;
        link.click();
      } else {
        alert('El archivo PDF está vacío o no se pudo obtener.');
      }
    } catch (error) {
      logError(error);
      console.error('Error al descargar el albarán:', error);
      alert('No se pudo descargar el albarán.');
    }
  };

export const handleDownloadSignedAlbaran = async (orderId) => {
    try {
      const response = await getSignedAlbaranPdf(orderId);

      if (response && response.data && response.data.base64Pdf) {
        const base64String = response.data.base64Pdf;

        const link = document.createElement('a');
        link.href = `data:application/pdf;base64,${base64String}`;
        link.download = response.data.fileName;
        link.click();
      } else {
        alert('El archivo PDF está vacío o no se pudo obtener.');
      }
    } catch (error) {
      logError(error);
      console.error('Error al descargar el albarán firmado:', error);
      alert('No se pudo descargar el albarán firmado.');
    }
  };

export const handleDownloadPhotos = async (orderId) => {
  try {
    const response = await getOrderPhotos(orderId);
    // Assume this returns an array of photo data
    return response.base64Photos;
  } catch (error) {
    logError(error);
    console.error('Error fetching photos:', error);
  }
};

export const handlePrintSummary = async (orderIds) => {
  if (!orderIds || orderIds.length === 0) return;
  
  try {
    const response = await getResumenPdf(orderIds);
    
    if (response?.data?.base64Pdf) {
      const base64String = response.data.base64Pdf;
      
      // Convertir base64 a Blob
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      
      // Crear URL de Blob y abrir ventana para imprimir
      const blobUrl = URL.createObjectURL(blob);
      const printWindow = window.open(blobUrl);
      printWindow.onload = () => {
        printWindow.focus();
        printWindow.print();
        URL.revokeObjectURL(blobUrl);
      };
    } else {
      alert('El archivo PDF está vacío o no se pudo obtener.');
    }
  } catch (error) {
    logError(error);
    console.error('Error al imprimir el resumen:', error);
    alert('No se pudo imprimir el resumen.');
  }
};
